import React from 'react'
import { FormControl, FormHelperText, Grid, makeStyles, TextField, Theme, createStyles, InputLabel, Select, Chip, MenuItem, Checkbox, ListItemText, FormLabel, RadioGroup, FormControlLabel, Radio, OutlinedInput } from '@material-ui/core'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';
import { typeCisDepartmentList } from '../../../../api/helpline/keiyaku';
import { green } from '@material-ui/core/colors';
import { typeForm } from '../../../../pages/ContractRegist';
import NumberFormatInput from '../../NumberFormatInput';
import { Autocomplete } from '@material-ui/lab';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    mWidth: {
      minWidth: "50%",
      maxWidth: "350px",
    },
    keiyakuWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "700px",
      minWidth: "400px"
    },
    lWidth: {
      marginTop: theme.spacing(1),
      maxWidth: "1000px",
      minWidth: "200px"
    },
    fullWidth: {
      width: '80%'
    },
    button: {
      margin: theme.spacing(1),
    },
    wrapper: {
      position: 'relative',
    },
    buttonProgress: {
      color: green[500],
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    chip: {
      margin: "2px 2px 2px"
    },
    chips: {
      display: "flex",
      flexWrap: "wrap"
    },
    legendlabel: {
      fontSize: '0.8rem'
    }
  }),
);

const ITEM_HEIGHT = 90;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      minWidth: 200,
      maxWidth: 200
    }
  }
};

interface Prop {
  reqinvoiceItem: {
    demandZipCd: boolean; demandAddress: boolean; demandCompanyName: boolean; demandPersonName: boolean; demandMonth: boolean; actionSeDeptCd: boolean;
  },
  handleChangeForm: (event: React.ChangeEvent<{ value: unknown; name?: string | undefined; }>) => void,
  form: typeForm | null | undefined,
  chipDelete: (i: number, name: string) => void,
  monthList: number[],
  checkinvoiceItem: { monthlyPrice: boolean; monthlyPrice2: boolean; demandZipCd: boolean; },
  monthSelect: { value: string, name: string }[],
  handleChangeDemandMonth: (event: React.ChangeEvent<HTMLInputElement>) => void,
  demandSelect: string,
  handleChangeDepartmentCd: (departmentObj: typeCisDepartmentList) => void,
  cisDepartmentList: typeCisDepartmentList[]
}

const InvoiceEditForm: React.FC<Prop> = (props) => {
  const classes = useStyles()
  const { reqinvoiceItem, handleChangeForm, form, chipDelete, monthList, checkinvoiceItem, monthSelect, handleChangeDemandMonth, demandSelect, handleChangeDepartmentCd, cisDepartmentList } = props

  return (
    <React.Fragment>
      {form &&
        <Grid container direction="row" justify="flex-start" alignItems="center" spacing={1}>
          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqinvoiceItem.demandZipCd || checkinvoiceItem.demandZipCd}>
                <TextField id="demandZipCd" name="demandZipCd" label="請求先 〒" value={form.demandZipCd}
                  size="small" onChange={handleChangeForm} variant="outlined" required error={reqinvoiceItem.demandZipCd || checkinvoiceItem.demandZipCd} />
                {reqinvoiceItem.demandZipCd ? <FormHelperText>必須項目です</FormHelperText> : checkinvoiceItem.demandZipCd ? <FormHelperText>不正な値です</FormHelperText> : (!reqinvoiceItem.demandZipCd && !reqinvoiceItem.demandAddress) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.keiyakuWidth} margin="dense" variant="outlined" error={reqinvoiceItem.demandAddress}>
                <TextField id="demandAddress" name="demandAddress" label="請求先 住所" value={form.demandAddress} size="small" onChange={handleChangeForm} variant="outlined" required error={reqinvoiceItem.demandAddress} />
                {reqinvoiceItem.demandAddress ? <FormHelperText>必須項目です</FormHelperText> : (!checkinvoiceItem.demandZipCd && !reqinvoiceItem.demandZipCd && !reqinvoiceItem.demandAddress) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
            <Grid item>
              <FormControl className={classes.keiyakuWidth} margin="dense" variant="outlined" error={reqinvoiceItem.demandCompanyName}>
                <TextField id="demandCompanyName" name="demandCompanyName" label="請求先 会社" value={form.demandCompanyName} size="small" onChange={handleChangeForm} variant="outlined" required error={reqinvoiceItem.demandCompanyName} />
                {reqinvoiceItem.demandCompanyName ? <FormHelperText>必須項目です</FormHelperText> : (!reqinvoiceItem.demandCompanyName && !reqinvoiceItem.demandPersonName) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined" error={reqinvoiceItem.demandPersonName}>
                <TextField id="demandPersonName" name="demandPersonName" label="請求先 氏名" value={form.demandPersonName} size="small" onChange={handleChangeForm} variant="outlined" required error={reqinvoiceItem.demandPersonName} />
                {reqinvoiceItem.demandPersonName ? <FormHelperText>必須項目です</FormHelperText> : (!reqinvoiceItem.demandCompanyName && !reqinvoiceItem.demandPersonName) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined" >
                <TextField id="InvoicedemandDeptName" name="demandDeptName" label="請求先 担当者部署" value={form.demandDeptName} size="small" onChange={handleChangeForm} variant="outlined" />
                {(!reqinvoiceItem.demandCompanyName && !reqinvoiceItem.demandPersonName) ? <FormHelperText></FormHelperText> : <FormHelperText >　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <TextField id="demandPostName" name="demandPostName" label="請求先 担当者役職" value={form.demandPostName} size="small" onChange={handleChangeForm} variant="outlined" />
                {(!reqinvoiceItem.demandCompanyName && !reqinvoiceItem.demandPersonName) ? <FormHelperText></FormHelperText> : <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
            <Grid item>
              <FormControl component="fieldset" variant="outlined" margin="dense">
                <FormLabel component="legend" className={classes.legendlabel}>請求方法</FormLabel>
                <RadioGroup row id="demandClsCd" name="demandClsCd" onChange={handleChangeDemandMonth} value={demandSelect}>
                  {monthSelect && (
                    monthSelect.map(value => (
                      <FormControlLabel value={value.value} key={value.value} control={<Radio color="primary" size="small" />} label={value.name} />
                    ))
                  )}
                </RadioGroup>
                {reqinvoiceItem.demandMonth && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl variant="outlined" className={classes.lWidth} margin="dense" error={reqinvoiceItem.demandMonth} required >
                <InputLabel id="demandMonth" variant="outlined">請求月</InputLabel>
                <Select labelId="demandMonth" id="demandMonth" label="請求月" name="demandMonth" multiple error={reqinvoiceItem.demandMonth}
                  value={form.demandMonth} onChange={handleChangeForm} MenuProps={MenuProps}
                  renderValue={(selected) => (
                    <div className={classes.chips}>
                      {(selected as number[]).map((value) => (
                        <Chip
                          className={classes.chip}
                          color="primary"
                          variant="outlined"
                          size="small"
                          key={value}
                          label={`${value}月`}
                          onMouseDown={(event) => {
                            event.stopPropagation();
                          }}
                          onDelete={(event) => chipDelete(value, 'demandMonth')} />
                      ))}
                    </div>
                  )}
                >
                  {monthList.map((value) => (
                    <MenuItem key={value} value={value}>
                      <Checkbox color="primary" checked={form.demandMonth.indexOf(value) > -1} />
                      <ListItemText primary={`${value}月`} />
                    </MenuItem>
                  ))}
                </Select>
                {reqinvoiceItem.demandMonth && <FormHelperText>必須項目です</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          <Grid container direction="row" justify="flex-start" alignItems="flex-end" spacing={1}>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined" >
                <InputLabel htmlFor="InvoicekeiyakuDeposit">契約金額</InputLabel>
                <OutlinedInput id="InvoicekeiyakuDeposit" name="keiyakuDeposit" value={form.keiyakuDeposit}
                  margin="dense" onChange={handleChangeForm} required disabled inputComponent={NumberFormatInput as any} labelWidth={70} />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <InputLabel htmlFor="incidentDeposit">ｵﾝｻｲﾄｲﾝｼﾃﾞﾝﾄｻｰﾋﾞｽ金額</InputLabel>
                <OutlinedInput id="incidentDeposit" name="incidentDeposit" value={form.incidentDeposit ? form.incidentDeposit : '0'} disabled margin="dense" onChange={handleChangeForm} inputComponent={NumberFormatInput as any} labelWidth={170} />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <InputLabel htmlFor="InvoicetotalPrice">合計金額</InputLabel>
                <OutlinedInput id="InvoicetotalPrice" name="totalPrice" value={form.totalPrice} disabled
                  margin="dense" onChange={handleChangeForm} required inputComponent={NumberFormatInput as any} labelWidth={70} />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <InputLabel htmlFor="monthlyPrice">請求金額(初回)</InputLabel>
                <OutlinedInput id="monthlyPrice" name="monthlyPrice" value={form.monthlyPrice} margin="dense" onChange={handleChangeForm} required inputComponent={NumberFormatInput as any} labelWidth={110} />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
            <Grid item>
              <FormControl className={classes.mWidth} margin="dense" variant="outlined">
                <InputLabel htmlFor="monthlyPrice2">請求金額(2回目以降)</InputLabel>
                <OutlinedInput id="monthlyPrice2" name="monthlyPrice2" value={form.monthlyPrice2} margin="dense" onChange={handleChangeForm} required inputComponent={NumberFormatInput as any} labelWidth={150} />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>　</FormHelperText>}
              </FormControl>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            {cisDepartmentList && cisDepartmentList[0] &&
              <FormControl className={classes.keiyakuWidth} variant="outlined" margin="dense" error={reqinvoiceItem.actionSeDeptCd}>
                <Autocomplete
                  id="actionSeDeptCd"
                  value={cisDepartmentList.filter(value => value.departmentCd === form.actionSeDeptCd)[0]}
                  disableClearable={true}
                  options={cisDepartmentList!}
                  getOptionLabel={(option) => `${option.departmentCd} ${option.departmentName}`}
                  onChange={(event, value, reason) => handleChangeDepartmentCd(value)}
                  renderInput={(params) => (
                    <TextField {...params} label="担当SE部門" variant="outlined" size="small" required error={reqinvoiceItem.actionSeDeptCd} />
                  )}
                  renderOption={(option, { inputValue }) => {
                    const matches = match(`${option.departmentCd} ${option.departmentName}`, inputValue);
                    const parts = parse(`${option.departmentCd} ${option.departmentName}`, matches);
                    return (
                      <div>
                        {parts.map((part, index) => (
                          <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                            {part.text}
                          </span>
                        ))}
                      </div>
                    );
                  }}
                />
                {reqinvoiceItem.actionSeDeptCd && <FormHelperText>必須項目です</FormHelperText>}
              </FormControl>
            }
          </Grid>
          <Grid item xs={12}>
            <FormControl className={classes.fullWidth} margin="dense" variant="outlined">
              <TextField id="demandNote" name="demandNote" label="備考(請求)" multiline size="small" value={form.demandNote} onChange={handleChangeForm} variant="outlined" />
              <FormHelperText>複数行入力できます</FormHelperText>
            </FormControl>
          </Grid>
        </Grid>
      }
    </React.Fragment>
  )
}

export default InvoiceEditForm